export default __webpack_public_path__ + "static/media/minion-what.af11e0b9.mp3";